<template>
    <div>
        <div class="card my-3">
            <div class="card-header">
                项目报名管理
            </div>
            <div class="card-body" style="min-height: 600px">
                <div v-if="canSignInClassData.length===0" class="alert alert-warning">没有可报名的班级信息</div>
                <div v-else>
                    <div class="card" :class="{'mt-3': index!==0}" v-for="(cls, index) in canSignInClassData">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-6">
                                    {{cls.className}}
                                </div>
                                <div class="col-6 text-right">
                                    {{cls.studentClassId? '已报名': '未报名'}}
                                </div>
                            </div>
                        </div>
                        <table class="table table-bordered mb-0">
                            <tbody>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">批次信息</th>
                                <td class="text-left align-middle" colspan="7">
                                    <div class="row">
                                        <div class="col" style="line-height: 27px">{{ cls.batchName }}</div>
                                        <div class="col-auto text-right">
                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectBatchInfoDialog_Click(cls.batchId)">
                                                批次基本信息
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">项目信息</th>
                                <td class="text-left align-middle" colspan="7">
                                    <div class="row">
                                        <div class="col" style="line-height: 27px">{{ cls.projectName }}</div>
                                        <div class="col-auto text-right">
                                            <router-link :to="{name: 'pdfView', params: {attFileId: cls.attFileId}}" target="_blank" class="btn btn-info btn-sm mr-2">培训实施方案</router-link>
                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectInfo_Click(cls.projectId)">项目基本信息
                                            </button>
                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectTeacherCourse_Click(cls.projectId)">
                                                课程安排信息
                                            </button>
<!--                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectAssessment_Click(projectId)">项目考核信息-->
<!--                                            </button>-->
<!--                                            <button class="btn btn-info btn-sm" @click="btnShowProjectAchievement_Click(projectId)">项目成果物信息-->
<!--                                            </button>-->
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">班级信息</th>
                                <td class="text-left align-middle" colspan="7">
                                    <div class="row">
                                        <div class="col" style="line-height: 27px">{{ cls.className }}</div>
                                        <div class="col-auto text-right">
<!--                                            <button class="btn btn-info btn-sm" @click="btnShowClassScheduleDialog_Click(cls.classId)">-->
<!--                                                教学日程信息-->
<!--                                            </button>-->
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">培训基地</th>
                                <td class="text-left align-middle" colspan="5">
                                    <a href="#" @click="btnShowOrganInfo_Click(cls.organId)">{{cls.organName}}</a>
                                </td>
                                <th class="text-center align-middle" style="width: 10%">联系人</th>
                                <td class="text-left align-middle" style="width: 15%">
                                    <a href="#" @click="btnShowClassContactInfoDialog_Click(cls.personId)">{{cls.personName}}</a>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">开始日期</th>
                                <td class="text-left align-middle" >{{cls.startDateString}}</td>
                                <th class="text-center align-middle" style="width: 10%">结束日期</th>
                                <td class="text-left align-middle" style="width: 15%">{{cls.endDateString}}</td>
                                <th class="text-center align-middle" style="width: 10%">计划人数</th>
                                <td class="text-left align-middle" style="width: 15%">{{cls.studentCount}}</td>
                                <th class="text-center align-middle" style="width: 10%">已报名人数</th>
                                <td class="text-left align-middle" style="width: 15%">{{cls.signInCount? cls.signInCount: 0}}</td>
                            </tr>
                            <tr v-if="cls.studentClassId">
                                <th class="text-center align-middle" colspan="3">院校确认状态</th>
                                <td class="text-left align-middle" >{{cls.collegeConfirmStateName}}</td>
                                <!-- 2025-12-25 经毕老师确认及教育厅沟通结果，去除主管部门确认环节 -->
                                <!-- <th class="text-center align-middle" colspan="2">主管部门确认状态</th>
                                <td class="text-left align-middle" >{{cls.adminConfirmStateName}}</td> -->
                                <th class="text-center align-middle" colspan="3">基地确认状态</th>
                                <td class="text-left align-middle" >{{cls.organConfirmStateName}}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="card-footer text-center">
                            <button class="btn btn-danger" @click="btnSignInClass_Click(cls.classId)" v-if="!cls.studentClassId">报名</button>
                            <button class="btn btn-danger" @click="btnCancelSignIn_Click(cls.studentClassId)" v-else
                                    :disabled="cls.collegeConfirmState!==studentSignInConfirmState.V1_NON_CONFIRM || cls.adminConfirmState!==studentSignInConfirmState.V1_NON_CONFIRM">取消报名</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <b-modal v-model="isShowProjectInfoViewDialogOpen"
                 title="项目实施详细信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <project-info-view :project-id="projectId"></project-info-view>
        </b-modal>
        <b-modal v-model="isShowProjectTeacherCourseViewDialogOpen"
                 title="课程安排详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <project-teacher-course-view :project-id="projectId" :show-teacher-info="false" :show-course-detail-info="false"></project-teacher-course-view>
        </b-modal>
<!--        <b-modal v-model="isShowProjectAssessmentViewDialogOpen"-->
<!--                 title="项目考核详细信息" size="lg"-->
<!--                 ok-title="确定" :ok-only="true"-->
<!--                 :no-close-on-backdrop="true">-->
<!--            <project-assessment-view :project-id="projectId"></project-assessment-view>-->
<!--        </b-modal>-->
<!--        <b-modal v-model="isShowProjectAchievementViewDialogOpen"-->
<!--                 title="项目成果物详细信息" size="lg"-->
<!--                 ok-title="确定" :ok-only="true"-->
<!--                 :no-close-on-backdrop="true">-->
<!--            <project-achievement-view :project-id="projectId"></project-achievement-view>-->
<!--        </b-modal>-->

        <b-modal v-model="isShowProjectBatchInfoDialogOpen"
                 title="项目批次详细信息"
                 ok-title="确定" :ok-only="true" size="xl"
                 :no-close-on-backdrop="true">
            <project-batch-info-view :batch-id="batchId"></project-batch-info-view>
        </b-modal>

        <b-modal v-model="isShowClassContactViewDialogOpen"
                 title="班级联系人信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <person-basic-info-view :person-id="personId" :person-type="personType" :show-detail-info="false"></person-basic-info-view>
            <person-contact-info-view :person-id="personId" :person-type="personType" class="mt-3"></person-contact-info-view>
        </b-modal>

<!--        <b-modal v-model="isShowClassScheduleInfoDialogOpen"-->
<!--                 title="班级教学日程安排信息" size="xl"-->
<!--                 ok-title="确定" :ok-only="true"-->
<!--                 :no-close-on-backdrop="true">-->
<!--            <project-class-schedule-view :class-id="classId"></project-class-schedule-view>-->
<!--        </b-modal>-->

        <b-modal v-model="isShowOrganInfoDialogOpen"
                 title="项目培训基地信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <organ-info-view :organ-id="organId" :show-warning-text="false"></organ-info-view>
        </b-modal>
    </div>
</template>

<script>
import dictionary from "@/utils/dictionary";
import studyApi from "@/utils/api/study";
import ProjectBatchInfoView from "@/components/infoView/ProjectBatchInfoView";
import ProjectInfoView from "@/components/infoView/ProjectInfoView";
import StudentClassDataManage from "@/components/study/StudentClassDataManage";
import ProjectTeacherCourseView from "@/components/project/project/ProjectTeacherCourseView";
import ProjectAssessmentView from "@/components/project/project/ProjectAssessmentView";
import PersonContactInfoView from "@/components/person/PersonContactInfoView";
import PersonBasicInfoView from "@/components/person/PersonBasicInfoView";
import ProjectClassScheduleView from "@/components/project/project/ProjectClassScheduleView";
import OrganInfoView from "@/components/user/OrganInfoView";
import ProjectAchievementView from "@/components/project/project/ProjectAchievementView";


export default {
    name: "StudentSignInManage",
    components: {
        OrganInfoView,
        ProjectInfoView,
        ProjectTeacherCourseView,
        ProjectAssessmentView,
        ProjectAchievementView,
        PersonContactInfoView,
        PersonBasicInfoView,
        ProjectBatchInfoView,
        ProjectClassScheduleView,
    },
    data: function () {
        return {
            studentId: this.$store.state.userInfo.userId,
            studentSignInConfirmState: dictionary.studentSignInConfirmState,
            studentClassState: dictionary.studentClassState,

            canSignInClassData: [],

            batchId: '',
            projectId: '',
            personId: '',
            classId: '',
            organId: '',
            personType: '',

            isShowProjectInfoViewDialogOpen: false,
            isShowProjectTeacherCourseViewDialogOpen: false,
            isShowProjectAssessmentViewDialogOpen: false,
            isShowProjectAchievementViewDialogOpen: false,

            isShowProjectBatchInfoDialogOpen: false,
            isShowClassContactViewDialogOpen: false,

            isShowClassScheduleInfoDialogOpen: false,

            isShowOrganInfoDialogOpen: false,
        };
    },
    mounted() {
        this.getCanSignInClassData();
    },
    methods: {
        getCanSignInClassData() {
            studyApi.studentClass.getSignInClassData(this.studentId).then(res => {
                this.canSignInClassData = res.data;
            });
        },

        btnSignInClass_Click(classId) {
            if (confirm('确定报名参加本班次的培训？')) {
                let info = {
                    classId: classId,
                    studentId: this.studentId
                };

                studyApi.studentClass.insertStudentClassInfo(info).then(res => {
                    this.getCanSignInClassData();
                });
            }
        },

        btnCancelSignIn_Click(studentClassId) {
            if (confirm('取消该班级的报名？')) {
                studyApi.studentClass.deleteStudentClassInfo(studentClassId).then(res => {
                    this.getCanSignInClassData();
                })
            }
        },

        btnShowProjectInfo_Click(projectId) {
            this.projectId = projectId;
            this.isShowProjectInfoViewDialogOpen = true;
        },
        btnShowProjectTeacherCourse_Click(projectId) {
            this.projectId = projectId;
            this.isShowProjectTeacherCourseViewDialogOpen = true;
        },
        btnShowProjectAssessment_Click(projectId) {
            this.projectId = projectId;
            this.isShowProjectAssessmentViewDialogOpen = true;
        },
        btnShowProjectAchievement_Click(projectId) {
            this.projectId = projectId;
            this.isShowProjectAssessmentViewDialogOpen = true;
        },

        btnShowProjectBatchInfoDialog_Click(batchId) {
            this.batchId = batchId;
            this.isShowProjectBatchInfoDialogOpen = true;
        },

        btnShowClassContactInfoDialog_Click(personId) {
            this.personId = personId;
            this.personType = dictionary.personType.ORGAN_IMPL_PERSON
            this.isShowClassContactViewDialogOpen = true;
        },
        btnShowClassScheduleDialog_Click(classId) {
            this.classId = classId;
            this.isShowClassScheduleInfoDialogOpen = true;
        },
        btnShowOrganInfo_Click(organId) {
            this.organId = organId;
            this.isShowOrganInfoDialogOpen = true;
        },

    }
}
</script>

<style scoped>

</style>